<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e2362168" style="color: #82a339"><b>VIETNAMESE NOODLE SOUP</b></p>
<p class="ext" id="d7e2362668"><b><i>Although Vietnamese soup is traditionally served with thinly sliced beef, our variation uses chicken breast meat. The flat, wide rice noodles </i> (bahn pho) <i>can be purchased in the Asian section of some grocery stores or in Asian markets.</i></b></p>
<p class="h4" id="d7e2365468" style="color: #496210"><b>Prep: 20 minutes Cook: 25 minutes</b></p>
<p class="ul" id="d7e2365968">4 ounces flat dried rice noodles or linguine</p>
<p class="ul" id="d7e2366268">3 green onions, thinly sliced on diagonal</p>
<p class="ul" id="d7e2366568">2 garlic cloves, peeled</p>
<p class="ul" id="d7e2366868">6 basil sprigs</p>
<p class="ul" id="d7e2367168">6 sprigs plus 2 tablespoons chopped fresh cilantro</p>
<p class="ul" id="d7e2367468">4 cans (14½ ounces each) low-sodium chicken broth <br/> or 7 cups Chicken Broth</p>
<p class="ul" id="d7e2369268">1 teaspoon coriander seeds</p>
<p class="ul" id="d7e2369568">1 cinnamon stick (3 inches)</p>
<p class="ul" id="d7e2369968">2 large skinless, boneless chicken breast halves <br/> (1 pound)</p>
<p class="ul" id="d7e2370568">4 medium mushrooms, trimmed and sliced <br/> mint sprigs <br/> lime wedges (optional)</p>
<p class="pub" id="d7e2371968" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In large bowl, soak rice noodles in enough <i>warm water to cover </i>20 minutes, or cook linguine as label directs. Drain.</p>
<p class="pub" id="d7e2373768"><span style="color: #c15b49"><b>2.</b></span> Meanwhile, in 3-quart saucepan, combine one-third of green onions, garlic, basil and cilantro sprigs, broth, coriander seeds, and cinnamon stick; heat to boiling over high heat. Reduce heat; cover and simmer 10 minutes. Strain through sieve set over bowl; discard solids. Return broth to saucepan.</p>
<p class="pub" id="d7e2376268"><span style="color: #c15b49"><b>3.</b></span> Cut chicken breast halves on diagonal into thin strips. Stir chicken, drained noodles, mushrooms, and remaining green onions into broth; heat to boiling over high heat. Reduce heat; cover and simmer until chicken loses its pink color throughout, about 3 minutes. Sprinkle with chopped cilantro and top with mint sprigs. Serve with lime wedges, if you like. Makes about 9 cups or 4 main-dish servings.</p>
<p class="ntx" id="d7e2379668">Each serving: About 269 calories, 30g protein, 27g carbohydrate, 2g total fat (0g saturated), 66mg cholesterol, 1,107mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c71_r1.vue?a8754be4